import { Component } from "react";
import HLSVideo from "./HLSVideo";
import { Slide } from "src/pods/ideas/data/types";

type VideoProps = {
  type: string;
  watch: Slide;
  autoplay: boolean;
  isExpanded?: boolean;
  isFullscreen?: boolean;
  isPlaying?: boolean;
  onPlaying?: VoidFunction;
  onPause?: VoidFunction;
  onEnd?: VoidFunction;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class Video extends Component<VideoProps> {
  /**
   * @return {ReactElement}
   */
  render() {
    const { type, watch } = this.props;

    if (type === "hls") {
      return (
        <HLSVideo
          ref={(video) => (this.video = video)}
          url={watch.hls_url!}
          captions={watch.captions || []}
          poster={watch.poster_url}
          autoplay={this.props.autoplay}
          isExpanded={this.props.isExpanded}
          isFullscreen={this.props.isFullscreen}
          isPlaying={this.props.isPlaying}
          onPlaying={this.props.onPlaying}
          onPause={this.props.onPause}
          onEnd={this.props.onEnd}
          sx={{ borderRadius: "dt_radius_s" }}
        />
      );
    }

    return null;
  }

  video: HLSVideo | null;

  /**
   * @param {Number} to
   */
  seek(to: number) {
    if (this.video) {
      this.video.seek(to);
    }
  }

  /**
   * @return {Number}
   */
  getCurrentTime(): number {
    return this.video ? this.video.getCurrentTime() : -1;
  }

  /**
   * @return {Number}
   */
  getDuration(): number {
    return this.video ? this.video.getDuration() : -1;
  }
}
